import { MapUiState } from '@/models/ui/MapUiState';
import { MeasureToolType } from '@/enum/MeasureToolType';
import { HoverData } from '@/models/ui/HoverData';
import { SoundNotification } from '@/enum/SoundNotification';
import deepmerge from 'deepmerge';
import { SmartPlanningUiState, buildDefaultSmartPlanningUiState } from '@/models/ui/SmartPlanningUiState';

export interface  IUiState {
  hideMap:boolean,
  uistates: any, //les etats de l'interface en fonction d'uiid
  snackMessages: Array<string>,
  draweropen: boolean,
  smartPlanningUiState:SmartPlanningUiState,
  soundNotification:SoundNotification,
  rightdraweropen: boolean,  
  darkmode:boolean,    
  allMissionVisibility: boolean,    
  allFleetVisibility: boolean,    
  missionMapVisibility:{[id:number]:boolean},
  missionDetailVisibility:{[id:number]:boolean},
  allSimulationVisibility: boolean,    
  simulationMapVisibility:{[id:number]:boolean},
  simulationDetailVisibility:{[id:number]:boolean},
  coverageMapVisibility:{[id:number]:Array<boolean>},
  coverageDetailVisibility:{[id:number]:Array<boolean>},
  //currentSimulationMapId:number,
  fleetMapVisibility:{[id:number]:boolean},
  fleetDetailVisibility:{[id:number]:boolean},
  currentMissionMapId:number,  
  coordFormatFilter: string,
  ongoingMissionActive: boolean,
  simulatedMissionActive: boolean,
  measureTool:string,
  refreshMesureTool:boolean,
  currentMovableDialog:{
    titleKey:string,
    cmp:string,
    uiid:string|null,
    isVisible:boolean
  },
  currentInfosDialog:{
    title: string,
    infos: string,
    urlinfos: string,
    isVisible: boolean
  },
  keys:any,
  redirectPath:string,
  graphHover:HoverData
}

//Initial State
//@ts-ignore
const state:IUiState = deepmerge({  
    hideMap:false,
    uistates: {
      map_global:new MapUiState({typeUiid:"global"}),
      map_picker:new MapUiState({typeUiid:"picker"})
    }, //les etats de l'interface en fonction d'uiid
    snackMessages: [],
    draweropen: true,
    smartPlanningUiState: buildDefaultSmartPlanningUiState(),
    darkmode:false,
    soundNotification: SoundNotification.Enable,
    rightdraweropen: true,    
    allMissionVisibility:true,
    allFleetVisibility:true,
    missionMapVisibility:{},
    missionDetailVisibility:{},  
    simulationMapVisibility:{},
    simulationDetailVisibility:{},    
    coverageMapVisibility:{},
    coverageDetailVisibility:{},
    fleetMapVisibility:{},
    fleetDetailVisibility:{},  
    currentMissionMapId:-1,  
    coordFormatFilter: 'formatEPSG4326ToHDMS',
    ongoingMissionActive: true,
    simulatedMissionActive: false,
    measureTool:MeasureToolType.NONE,
    refreshMesureTool:false,
    currentMovableDialog:{
      titleKey:'',
      cmp:'',
      uiid:'',
      isVisible:false
    },
    currentInfosDialog:{
      title: '',
      infos: '',
      urlinfos: '',
      isVisible:false
    },
    keys:{},
    redirectPath:'/',
    graphHover:new HoverData()
  }
  ,{ coordFormatFilter: localStorage?.getItem('coordFormatFilter') ?? 'formatEPSG4326ToHDMS',soundNotification: localStorage?.getItem('soundNotification') as SoundNotification ?? SoundNotification.Enable})

export default state